module.exports = __webpack_public_path__ + "img/coronavirus-letters-logo.9f676ba3.png";